module.exports = __webpack_public_path__ + "static/media/real-time.4349b4d3.png";